import { Model } from "./model";
import { Contact } from "./contact";

export class Ticket extends Model {

  constructor(
    public id?: number,
    public contactId?: number,
    public ticketAllocationId?: number,
    public purchaseDate: Date = null,

    public contact: Contact = null,

    // TODO: Consider moving all of uiState to an interface
    public uiState: any = {},
    public createdAt: Date = null,
    public updatedAt: Date = null,
  ) { super(); }

  static clone(obj: any) {
    const e = new this();

    if (obj.id) { e.id = obj.id }
    if (obj.contactId) { e.contactId = obj.contactId }
    if (obj.ticketAllocationId) { e.ticketAllocationId = obj.ticketAllocationId }
    if (obj.purchaseDate) { e.purchaseDate = new Date(obj.purchaseDate) }

    if (obj.contact) { e.contact = Contact.clone(obj.contact) }

    if (obj.createdAt) { e.createdAt = new Date(obj.createdAt) }
    if (obj.updatedAt) { e.updatedAt = new Date(obj.updatedAt) }

    return e;
  }

}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/models/ticket.ts